import { NOT_FOUND_VALUE } from 'features/EntityDetails/components/EntityDetails/EntityDetail/components/EntityDetailValue';
import { IBaseEntity, IDraftEntityResponse } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { DraftStatus, LiveStatus } from 'utils/statuses';

const initialEntityDetails: IBaseEntity = {
  spaceId: NOT_FOUND_VALUE,
  name: NOT_FOUND_VALUE,
  mediaOwnerName: NOT_FOUND_VALUE,
  environment: NOT_FOUND_VALUE,
  formatSize: null,
  internetAccessAvailable: false,
  averageWeeklyImpactsAvailable: 0,
  planningRateCpm: NOT_FOUND_VALUE,
  currency: NOT_FOUND_VALUE,
  audienceDataSource: NOT_FOUND_VALUE,
  venueType: null,
  auctionToSpotTimeMinutes: 0,
  allowedMimeTypes: NOT_FOUND_VALUE,
  operatingHours: null,
  tags: [],
  latitude: 0,
  longitude: 0,
  zip: NOT_FOUND_VALUE,
  nativeResolution: NOT_FOUND_VALUE,
  consolidatedResolutions: [NOT_FOUND_VALUE],
  width: 0,
  height: 0,
  entityType: EntityType.FRAME,
};

export const initialDraftEntityResponseState: IDraftEntityResponse = {
  draft: {
    ...initialEntityDetails,
    linkedAssetFrames: [],
    broadsignFrames: [],
    status: DraftStatus.READY,
    intendedLiveStatus: LiveStatus.ACTIVE,
    draftErrors: [],
  },
  previous: {
    ...initialEntityDetails,
    linkedAssetFrames: [],
    broadsignFrames: [],
    status: LiveStatus.ACTIVE,
    hasDraft: false,
  },
};
